// extracted by mini-css-extract-plugin
export default {"content-wrapper":"NVWHlN","title":"dZ0fug"};